import { date, isEmpty, showAlert } from '../../../lib/helpers';
import {
  dataSourceOnboardingList,
  dataListMerchantCriteria,
  dataListAccountStatus,
  dataQrType,
  dataSettlementTypeItems,
} from '../../../store/params';
import { headers, search } from './attributes';


export default {
  data: () => ({
    listButton: {
      buttonRestart: true,
      buttonDots: true,
      buttonDotsExt: [
        {
          link: 'exportItemParent',
          show: true,
          icon: 'mdi-file-excel',
          title: 'Export to excel',
          voidStatus: true,
        },
      ],
    },
    isFirstLoad: true,
    page: '1',
    options: {},
    headers,
    editedIndex: -1,
    search,
    filterValue: { source_onboarding: '', aggregator_name: '', merchant_name: '', mid: '', nmid: '', mpan: '', address: '', merchant_criteria: '', qr_type: '', settlement_type:'', bcko: '', cmer: '', created_at: [], deactivated_at: [], status: '' },
    searchBcko: '',
    searchCmer: '',
    bckoList: [],
    cmerList: [],
    loadingBcko: false,
    loadingCmer: false,
    selectedBckoId: '',
    selectedCmerId: '',
  }),

  computed: {
    filterConfig() {
      return [
        { key: 'source_onboarding', type: 'select', props: { label: 'Source Onboarding', items: dataSourceOnboardingList } },
        { key: 'merchant_name', type: 'textfield', props: { label: 'Nama Sub Merchant' } },
        { key: 'mid', type: 'textfield', props: { label: 'MID' } },
        { key: 'nmid', type: 'textfield', props: { label: 'NMID' } },
        { key: 'mpan', type: 'textfield', props: { label: 'MPAN' } },
        { key: 'address', type: 'textfield', props: { label: 'Alamat Lengkap' } },
        { key: 'merchant_criteria', type: 'select', props: { label: 'Kriteria Merchant', items: dataListMerchantCriteria } },
        { key: 'qr_type', type: 'select', props: { label: 'Jenis QR', items: dataQrType } },
        { key: 'settlement_type', type: 'select', props: { label: 'Settlement Type', items: dataSettlementTypeItems } },
        {
          key: 'bcko',
          type: 'autocomplete',
          props: {
            label: 'Branch Code BC/KO',
            items: this.bckoList,
            loading: this.loadingBcko,
            itemText: 'display_text',
            itemValue: 'id',
            search: this.searchBcko,
          }
        },
        {
          key: 'cmer',
          type: 'autocomplete',
          props: {
            label: 'Merchant Category Segment',
            items: this.cmerList,
            loading: this.loadingCmer,
            itemText: 'display_text',
            itemValue: 'id',
            search: this.searchCmer,
          }
        },
        { key: 'created_at', type: 'daterange', props: { label: 'Tanggal Active', includeToday: true } },
        { key: 'deactivated_at', type: 'daterange', props: { label: 'Tanggal Inactive', includeToday: true } },
        { key: 'status', type: 'select', props: { label: 'Status', items: dataListAccountStatus } },
      ];
    },
    flashErrorMessage() {
      return this.$store.state.client.aggregator.flashErrorMessage;
    },

    flashError: {
      get() {
        return this.$store.state.client.aggregator.flashError;
      },
      set() {
        this.$store.commit('client/aggregator/setFlashErrorMessage', '');
      },
    },

    loading() {
      return this.$store.state.client.aggregator.loading;
    },
    allData() {
      return this.$store.state.client.aggregator.allMerchants;
    },
    totalData() {
      return this.$store.state.client.aggregator.totalMerchants;
    },
    totalPage() {
      return this.$store.state.client.aggregator.totalPage;
    },
    idAggregator() {
      return this.$route.params.id;
    },
    filterAllow() {
      return (
        isEmpty(this.search.source_onboarding) &&
        isEmpty(this.search.merchant_name) &&
        isEmpty(this.search.nmid) &&
        isEmpty(this.search.mpan) &&
        isEmpty(this.search.mobile_phone) &&
        isEmpty(this.search.mid) &&
        isEmpty(this.search.merchant_criteria) &&
        isEmpty(this.search.qr_type) &&
        isEmpty(this.search.address) &&
        isEmpty(this.search.settlement_type) &&
        isEmpty(this.search.bcko) &&
        isEmpty(this.search.cmer) &&
        isEmpty(this.search.status) &&
        this.search.created_at.length < 1 &&
        this.search.deactivated_at.length < 1
      );
    },
  },

  watch: {
    options: {
      handler() {
        if (!this.isFirstLoad) {
          this.getData();
        } else {
          this.$store.commit('client/aggregator/clearMerchants');
        }
        this.isFirstLoad = false;
      },
      deep: true,
    },

    show() {
      if (!this.show) {
        this.clearSearch();
      }
    },

    searchBcko(val, oldVal) {
      if (!val && !oldVal) return;
      if (this.isSelectedDisplayText('bcko', val)) return;
      this.debouncedFetchBcko(val || '');
    },

    searchCmer(val, oldVal) {
      if (!val && !oldVal) return;
      if (this.isSelectedDisplayText('cmer', val)) return;
      this.debouncedFetchCmer(val || '');
    },
  },

  created() {
    this.debouncedFetchBcko = this.createDebounced(this.fetchBckoList, 300);
    this.debouncedFetchCmer = this.createDebounced(this.fetchCmerList, 300);
  },

  async mounted() {
    this.$store.commit('client/aggregator/clearMerchants');
    this.fetchBckoList();
    this.fetchCmerList();
  },

  methods: {
    baseFilterData(newSearch) {
      this.search.source_onboarding = newSearch.source_onboarding || '';
      this.search.merchant_name = newSearch.merchant_name || '';
      this.search.mid = newSearch.mid || '';
      this.search.nmid = newSearch.nmid || '';
      this.search.mpan = newSearch.mpan || '';
      this.search.address = newSearch.address || '';
      this.search.merchant_criteria = newSearch.merchant_criteria || '';
      this.search.qr_type = newSearch.qr_type || '';
      this.search.settlement_type = newSearch.settlement_type || '';
      this.search.bcko = newSearch.bcko || '';
      this.search.cmer = newSearch.cmer || '';
      this.search.created_at = newSearch.created_at || [];
      this.search.deactivated_at = newSearch.deactivated_at || [];
      this.search.status = newSearch.status || '';
      this.options.page = 1;
      this.getData();
    },
    updateSearch(newSearch) {
      this.baseFilterData(newSearch);
    },
    showType(newSearch) {
      this.baseFilterData(newSearch);
    },
    isEmpty,

    clearSearch() {
      this.search.source_onboarding = '';
      this.search.merchant_name = '';
      this.search.nmid = '';
      this.search.mpan = '';
      this.search.mobile_phone = '';
      this.search.mid = '';
      this.search.merchant_criteria = '';
      this.search.qr_type = '';
      this.search.address = '';
      this.search.settlement_type = '';
      this.search.bcko = '';
      this.search.cmer = '';
      this.search.status = '';
      this.search.created_at = [];
      this.search.deactivated_at = [];
      this.searchBcko = '';
      this.searchCmer = '';
      this.selectedBckoId = '';
      this.selectedCmerId = '';
      this.$nextTick(() => {
        this.$router.push({ query: {} });
        this.$store.commit('client/aggregator/clearMerchants');
      });
    },

    getData() {
      if (this.filterAllow) {
        this.$vuetify.goTo(0);
        showAlert(
          this.$store,
          'One on the field need to be filled !',
          'mdi-alert',
          'red'
        );
        this.$store.commit('client/aggregator/clearMerchants');
      } else {

        this.$store.commit('client/aggregator/setFlashErrorMessage', '');
        const { page, itemsPerPage, sortBy, sortDesc } = this.options;
        this.$store
          .dispatch('client/aggregator/fetchMerchants', {
            date,
            page,
            itemsPerPage,
            sortBy,
            sortDesc,
            search: this.search,
            aggregatorId: this.$route.params.id,
            merchantId: null,
            action: 'merchant',
          })
          .then(() => {
            if (this.totalPage < page) {
              if (this.totalPage === 0) {
                this.options.page = 1;
              } else {
                this.options.page = this.totalPage;
              }
            }
          });
      }
    },

    listItem(item) {
      if (this.idAggregator != null) {
        this.$router.push({
          path: `/client/aggregator/${this.$route.params.id}/sub-merchant/${item.id}/list-outlet`,
        });
      } else {
        this.$router.push({
          path: `${'/client/sub-merchant/'}${item.id}/list-outlet`,
        });
      }
    },

    exportItem() {
      if (this.filterAllow) {
        this.$vuetify.goTo(0);
        showAlert(
          this.$store,
          'Data is empty !',
          'mdi-alert',
          'red'
        );
        this.$store.commit('client/aggregator/clearMerchants');
      } else {
        const { page, itemsPerPage, sortBy, sortDesc } = this.options;
        this.$store.dispatch('client/aggregator/exportList', {
          date,
          page,
          itemsPerPage,
          sortBy,
          sortDesc,
          search: this.search,
          view: 'sub-merchant',
          IDAggregator:
            this.$route.params.id === undefined ? '' : this.$route.params.id,
          IDMerchant: '',
        });
      }
    },

    async fetchBckoList(keyword = '') {
      this.loadingBcko = true;
      const result = await this.$store.dispatch('bckoShared/getBcko', { keyword, showAll: true, limit: 9999 });
      if (result.success) {
        this.bckoList = result.data.map(item => ({
          ...item,
          display_text: `${item.branch_code_bcko} - ${item.outlet_name}`,
        }));
      }
      this.loadingBcko = false;
    },

    async fetchCmerList(keyword = '') {
      this.loadingCmer = true;
      const result = await this.$store.dispatch('cmerShared/getCmer', { keyword, showAll: true, limit: 9999 });
      if (result.success) {
        this.cmerList = result.data.map(item => ({
          ...item,
          display_text: `${item.code} - ${item.definition}`,
        }));
      }
      this.loadingCmer = false;
    },

    handleFilterSearchInput(payload) {
      const { key, value } = payload || {};
      if (key === 'bcko') {
        this.searchBcko = value;
      } else if (key === 'cmer') {
        this.searchCmer = value;
      }
    },

    handleFilterValueChange(payload) {
      const { key, value } = payload || {};
      if (key === 'bcko') {
        this.selectedBckoId = value || '';
      } else if (key === 'cmer') {
        this.selectedCmerId = value || '';
      }
    },

    isSelectedDisplayText(field, val) {
      const selectedId = field === 'bcko' ? this.selectedBckoId : this.selectedCmerId;
      if (!selectedId || !val) return false;
      const list = field === 'bcko' ? this.bckoList : this.cmerList;
      const selected = list.find(item => item.id === selectedId);
      return !!(selected && selected.display_text === val);
    },

    createDebounced(fn, delay) {
      let timer = null;
      return (...args) => {
        if (timer) clearTimeout(timer);
        timer = setTimeout(() => fn.apply(this, args), delay);
      };
    },
  },
  beforeRouteLeave(to, from, next) {
    this.clearSearch();
    next();
  },
};